import { NavLink } from 'react-router-dom'
import { wavePlanPath } from './plans'
import { ChartNoAxesCombined, Layers3, Warehouse } from 'lucide-react'

export function WavePlanningNav({
  planId,
  compact = false,
}: {
  planId: string
  compact?: boolean
}) {
  return (
    <nav
      aria-label="Wave planning views"
      className="flex gap-1 overflow-x-auto border-b"
    >
      {[
        {
          to: wavePlanPath(planId),
          label: 'Overall plan',
          icon: ChartNoAxesCombined,
        },
        {
          to: wavePlanPath(planId, 'skus'),
          label: 'SKU detail',
          icon: Layers3,
        },
        {
          to: wavePlanPath(planId, 'distribution-centers'),
          label: 'Distribution centers',
          icon: Warehouse,
        },
      ].map(({ to, label, icon: Icon }, index) => (
        <NavLink
          key={to}
          to={to}
          end
          className={({ isActive }) =>
            `inline-flex shrink-0 items-center gap-2 border-b-2 px-3 ${compact ? 'py-2' : 'py-3'} text-xs font-medium transition-colors ${isActive ? 'border-primary text-primary' : 'border-transparent text-muted-foreground hover:bg-secondary hover:text-foreground'}`
          }
        >
          <Icon size={15} />
          <span className="hidden sm:inline text-[10px] opacity-60">
            0{index + 1}
          </span>
          {label}
        </NavLink>
      ))}
    </nav>
  )
}
